import { motion } from "framer-motion";

const Contact = () => {
  // Framer Motion Variants
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.5,
        duration:0.8,
        ease:"easeOut",
        staggerChildren: 0.2,
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.5,
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const childVariants1 = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.5,
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };
  return (
    <section className="contact-section py-24 bg-gradient-to-r from-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        {/* Heading */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={containerVariants}
          viewport={{ once: false, amount: 0.2 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-800 mb-4 text-white">
            Contact Us
          </h2>
          <p className="text-lg text-gray-600 text-white">
            We'd love to hear from you! Reach out to us via the details below.
          </p>
        </motion.div>

        {/* Contact Section Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-12"
        >
          {/* Map Section */}
          <motion.div
            variants={childVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            className="rounded-lg shadow-lg overflow-hidden"
          >
            <iframe
              title="Location Map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2433.3756470760277!2d78.3703223!3d17.4512804!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93c48ffb8743%3A0x5aa4aa0466861cc1!2sN-Heights%2C%20Siddiq%20Nagar%2C%20HITEC%20City%2C%20Hyderabad%2C%20Telangana%20500081!5e1!3m2!1sen!2sin!4v1739379292486!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              className="h-64 md:h-full"
            ></iframe>
          </motion.div>

          {/* Contact Details Section */}
          <motion.div
            variants={childVariants1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            className="bg-white p-8 rounded-lg shadow-lg"
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-6">
              Get In Touch
            </h3>
            <p className="text-gray-600 mb-4">
              <strong>Address:</strong> Plot No 12, 4th floor, Software Units Layout, Madhapur, Hyderabad, Telangana - 500081
            </p>
            <p className="text-gray-600 mb-4">
            <strong>Email:</strong> hr@zenetixitsolutions.com
            </p>
            <p className="text-gray-600 mb-4">
              <strong>Phone:</strong> +91 7799799100
            </p>
            <p className="text-gray-600 mb-4">
              <strong>Business Hours:</strong> Mon - Fri: 9:00 AM - 6:00 PM
            </p>

            <div className="flex space-x-4 mt-6">
              <a
                href="mailto:hr@zenetixitsolutions.com"
                className="bg-blue-900 no-underline hover:bg-blue-700 hover:scale-110 text-white px-4 py-2 rounded-lg transition-all duration-300"
              >
                Email Us
              </a>
              <a
                href="tel:7799799100"
                className="bg-gray-900 no-underline hover:bg-gray-700 hover:scale-110 text-white px-4 py-2 rounded-lg transition-all duration-300"
              >
                Call Now
              </a>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
